// src/components/Loader.jsx
import React from "react";
import { Box, Typography, keyframes } from "@mui/material";

// Rotate animation for the outer circle
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

function Loader({ message = "Loading NoorNikah..." }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100vw",
        backgroundColor: "#FFF9F1", // app background
        textAlign: "center",
        position: "relative",
      }}
    >
      {/* Outer rotating circle */}
      <Box
        sx={{
          position: "relative",
          width: { xs: 120, sm: 160 },
          height: { xs: 120, sm: 160 },
          mb: 4,
        }}
      >
        {/* Spinning ring */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            border: "4px solid #E0DDF3", // background ring color
            borderTop: "4px solid #4b0082", // spinning color
            borderRadius: "50%",
            animation: `${spin} 1.5s linear infinite`,
          }}
        />
        {/* Static center logo */}
        <Box
          component="img"
          src="/logos.png" // public/logo.png
          alt="NoorNikah Logo"
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            width: { xs: 60, sm: 100 },
            height: { xs: 60, sm: 100 },
            transform: "translate(-50%, -50%)",
          }}
        />
      </Box>

      {/* Loading message */}
      <Typography
        variant="h6"
        sx={{
          color: "#4b0082",
          fontWeight: "600",
          fontFamily: "'Poppins', sans-serif",
        }}
      >
        {message}
      </Typography>
    </Box>
  );
}

export default Loader;
